/**
 * navigation/navigationRef.ts
 * Container-level navigation ref so the sidebar (which renders outside the
 * content navigator) can drive navigation and read the active route.
 */
import { createNavigationContainerRef } from '@react-navigation/native';
import type { AppStackParamList, AppRouteName } from './types';

export const navigationRef = createNavigationContainerRef<AppStackParamList>();

/** Navigate the app stack from outside a screen (no-op until the container mounts). */
export function navigateApp<Name extends AppRouteName>(name: Name, params?: AppStackParamList[Name]): void {
  if (navigationRef.isReady()) {
    (navigationRef.navigate as (n: Name, p?: AppStackParamList[Name]) => void)(name, params);
  }
}
